import {
  Radio,
  Paper,
  Typography,
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  TextField,
  Checkbox,
  Card,
  Button,
} from "@mui/material";
import { Grid } from "@mui/material";
import { connect, useSelector } from "react-redux";
import React, { useState } from "react";
import StripeCheckout from "../../../User/Cart/StripeCheckout";
import {
  toggleSignUp,
  getUserDetails,
} from "../../../../store/actions/user/User";
import { getVendorDetails } from "../../../../store/actions/vendor/Vendor";
import { getCommision } from "../../../../helpers/general.helper";
import SignIn from "./SignIn";
import classes from "./PaymentsCard.module.css";

function CardSection({ onSuccess, price }) {
  const proceedToPayment = (data) => {
    if (onSuccess) {
      onSuccess(data);
    }
  };
  return (
    <Grid container>
      {/* <FormControl
        fullWidth
        size="sm"
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          display: "flex",
          gap: "1rem",
        }}
      >
        <Grid xs="12" sm="12">
          <Typography
            align="left"
            fontWeight={700}
            sx={{ marginBottom: "0.5rem" }}
          >
            Card Number
          </Typography>
          <TextField fullWidth id="card-number" variant="outlined" />
        </Grid>
        <Grid xs="6" sm="6" style={{ flexBasis: "calc(50% - 0.5rem)" }}>
          <Typography
            align="left"
            fontWeight={700}
            sx={{ marginBottom: "0.5rem" }}
          >
            Expiration Date
          </Typography>
          <TextField fullWidth id="card-expiry-date" variant="outlined" />
        </Grid>
        <Grid xs="6" sm="6" style={{ flexBasis: "calc(50% - 0.5rem)" }}>
          <Typography
            align="left"
            fontWeight={700}
            sx={{ marginBottom: "0.5rem" }}
          >
            CVV
          </Typography>
          <TextField fullWidth id="card-cvv" variant="outlined" />
        </Grid>
      </FormControl>
      <FormControl>
        <FormControlLabel
          value="end"
          control={<Checkbox />}
          label="Save card details"
          sx={{ color: "#acacac", marginTop: "0.5rem" }}
          labelPlacement="end"
        />
      </FormControl> */}
      <StripeCheckout handlePayment={proceedToPayment} price={price} />
    </Grid>
  );
}

function PaymentsCard(props) {
  let CommissionDiscount = props.adminCommission.value;
  const [paymentOption, setPaymentOption] = useState("card");
  const ancillaryServices = useSelector(
    (state) => state.flight.ancillaryServices
  );
  const vendor = useSelector((state) => state.vendor);
  const admin = useSelector((state) => state.admin);

  function changePaymentType(event) {
    setPaymentOption(event.target.value);
  }

  const getBaggagePrice = () => {
    if (!ancillaryServices?.baggage) return 0;
    let totalBaggagePrice = 0;
    Object.values(ancillaryServices.baggage).forEach((baggage) => {
      if (baggage && baggage.Price) {
        return (totalBaggagePrice += parseInt(baggage.Price));
        // Add commission to baggage price
      }
    });
    return Math.round(totalBaggagePrice);
  };

  const getMealPrice = () => {
    if (!ancillaryServices?.meals) return 0;
    let totalMealPrice = 0;
    Object.values(ancillaryServices.meals).forEach((meal) => {
      if (meal.Price) {
        totalMealPrice += parseInt(meal.Price);
      }
    });
    return totalMealPrice;
  };

  const getCommisionPrice = () => {
    let commissionType = "";
    let commissionValue = 0;
    let vendorCurrency;
    if (vendor && vendor.vendorDetail) {
      commissionType = vendor.vendorDetail.commissionType;
      commissionValue = vendor.vendorDetail.commissionValue;
      vendorCurrency = vendor.vendorDetail.currency;
    }
    let adminCommissionType = "Fixed";
    let adminCommissionValue = 0;
    if (admin && admin.commission && admin.commission.commissionType) {
      adminCommissionType = admin.commission.commissionType;
      adminCommissionValue = admin.commission.commissionValue;
    }
    return {
      commissionType: commissionType,
      commissionValue: commissionValue,
      vendorCurrency,
      adminCommissionType,
      adminCommissionValue,
    };
  };

  const getTotal = () => {
    let price = 0;
    if (props.price) {
      price = parseInt(props.price);
    } else if (props.flight && props.flight.total_price) {
      price = parseInt(props.flight.total_price);
    } else if (props.flight && props.flight.price) {
      price = parseInt(props.flight.price);
    }

    const {
      commissionType,
      commissionValue,
      adminCommissionType,
      adminCommissionValue,
    } = getCommisionPrice();
    price += getCommision(price, commissionType, commissionValue);
    price += getCommision(price, adminCommissionType, adminCommissionValue);
    // Add baggage price
    price += getBaggagePrice();

    // Add meal price
    price += getMealPrice();

    if (CommissionDiscount) price += CommissionDiscount;

    return Math.round(price);
  };
  return (
    <Card style={{ padding: "2rem" }}>
      <Typography
        align="left"
        variant="h6"
        fontWeight={600}
        style={{ paddingBottom: "1.25rem", textTransform: "capitalize" }}
        color="#000000"
      >
        Payment
      </Typography>
      {props.auth ? (
        <>
          <FormControl style={{ display: "flex", marginTop: "1.5rem" }}>
            <FormLabel align="left" sx={{ fontWeight: 600 }}>
              Pay With
            </FormLabel>
            <RadioGroup
              value={paymentOption}
              name="radio-buttons-group"
              style={{ flexDirection: "row" }}
            >
              <FormControlLabel
                onChange={changePaymentType}
                value="card"
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "#00846A",
                      },
                    }}
                  />
                }
                label="Card"
              />
              <FormControlLabel
                onChange={changePaymentType}
                value="upi"
                control={
                  <Radio
                    sx={{
                      "&.Mui-checked": {
                        color: "#00846A !important",
                      },
                    }}
                  />
                }
                label="UPI"
              />
              {localStorage.getItem("userLoginType") == "vendor" &&
              props.vendorDetail?.walletAmount &&
              props.vendorDetail?.walletAmount >= getTotal() ? (
                <FormControlLabel
                  value="wallet"
                  onChange={changePaymentType}
                  control={<Radio />}
                  label={`Use Wallet Balance (Wallet Balance ${
                    props.vendorDetail?.walletAmount || 0
                  })`}
                />
              ) : (
                <></>
              )}
            </RadioGroup>
            {paymentOption == "wallet" ? (
              <div>
                <Grid xs="12" sm="12" md="12" className={classes.pay_content}>
                  <Typography
                    align="left"
                    sx={{ color: "#acacac", textAlign: "justify" }}
                  >
                    I have read and I accept the Terms & Conditions, including
                    the terms of the Travelpick.io Guarantee and Refund &
                    Cancellation Policy, as well as the Privacy Policy of
                    Travelpick.io and my selected carrier(s). I also agree with
                    Travelpick's immediate performance of services and I
                    acknowledge that I cannot withdraw from Travelpick.io
                    service agreement.
                  </Typography>
                  <FormControl sx={{ display: "flex" }}>
                    <FormControlLabel
                      value="end"
                      control={<Checkbox />}
                      sx={{ color: "#acacac" }}
                      label="I agree the terms and conditions"
                      labelPlacement="end"
                    />
                  </FormControl>
                </Grid>
                <Grid xs="12" sm="12" md="12">
                  <Button
                    sx={{
                      padding: "10px 20px",
                      width: "100%",
                      border: "1px transparent",
                      borderRadius: "5px",
                      backgroundColor: "#00846A",
                      color: "#fff",
                      "&:hover": {
                        backgroundColor: "#00846A",
                      },
                    }}
                    onClick={() => {
                      props.onSuccess({ id: "NOT_REQUIRED" });
                    }}
                  >
                    Proceed To Pay
                  </Button>
                </Grid>
              </div>
            ) : (
              <></>
            )}
          </FormControl>
          {paymentOption === "card" && (
            <Grid container>
              <Grid xs="12" sm="12" md="6" className={classes.pay_form}>
                <CardSection onSuccess={props.onSuccess} price={getTotal()} />

                {/*<button className={classes["pay-btn"]}>{props.price}</button> */}
              </Grid>
              <Grid xs="12" sm="12" md="6" className={classes.pay_content}>
                <Typography
                  align="left"
                  sx={{ color: "#acacac", textAlign: "justify" }}
                >
                  I have read and I accept the Terms & Conditions, including the
                  terms of the Travelpick.io Guarantee and Refund & Cancellation
                  Policy, as well as the Privacy Policy of Travelpick.io and my
                  selected carrier(s). I also agree with Travelpick's immediate
                  performance of services and I acknowledge that I cannot
                  withdraw from Travelpick.io service agreement.
                </Typography>
                <FormControl sx={{ display: "flex" }}>
                  <FormControlLabel
                    value="end"
                    control={<Checkbox />}
                    sx={{ color: "#acacac" }}
                    label="I agree the terms and conditions"
                    labelPlacement="end"
                  />
                </FormControl>
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        <SignIn />
      )}
    </Card>
  );
}

const mapStateWithProps = (state) => ({
  auth: state.user.auth,
  userDetails: state.user.userDetails,
  vendorDetail: state.vendor.vendorDetail,
  passengers: state.flight.passengers,
  flight: state.flight.selectedFlight,
});

const mapDispatchToProps = (dispatch) => ({
  getUserDetails: () => dispatch(getUserDetails()),
  getVendorDetails: () => dispatch(getVendorDetails()),
});

export default connect(mapStateWithProps, mapDispatchToProps)(PaymentsCard);
